export class GetReminderRequest{
    public crmUserId:number;
    public sessionToken:string;
    public searchByUser:boolean;
    public searchCompleted:boolean;
    public searchCriteriaId:number;
}